import { sendEvent } from "./sendEvent"

export type AnalyticsEventData = {
    eventCategory: string
    eventAction: string
    eventLabel?: string
    eventValue?: number
    nonInteraction?: boolean
}
type AnalyticsEventArgs = ["send", "event" | "pageview", AnalyticsEventData | string]

// It keeps all GA actions before user makes a choice of the policy
let quere: AnalyticsEventArgs[] = []
let gaScriptIsLoaded = false
let GAClientID: string | undefined // it is not used now but may be in the future

/**
 * The function execute GA action if the script is ready
 * othewise it puts the action into quere
 * @param params array of ga arguments
 */
function gaApply(params: AnalyticsEventArgs): void {
    const gaIsDeclined = window.Cookiebot.consented == false
    if (gaIsDeclined) {
        if (quere.length) quere = []
        return
    }
    if (gaScriptIsLoaded) {
        ga(...params)
    } else {
        quere.push(params)
    }
}

/**
 * The function initiates GA script and saves GA id to the global var
 */
const initScript: VoidFunction = () => {
    window.ga =
        window.ga ||
        function (): void {
            // eslint-disable-next-line prefer-rest-params
            ;(ga.q = ga.q || []).push(arguments)
        }
    ga.l = +new Date()
    ga("create", "UA-55337025-1", { allowAnchor: true })
    const marketingConsentIsDeclined = window.Cookiebot.consent.marketing == false
    if (marketingConsentIsDeclined) {
        ga("set", "allowAdFeatures", false)
    } else {
        ga("set", "allowAdFeatures", true)
    }
    ga((tracker) => {
        GAClientID = tracker ? tracker.get("clientId") : undefined
    })

    /* Adds an event when the user is about to leave the page : baby don't go */
    window.addEventListener("beforeunload", () => {
        sendEvent({ eventCategory: "Departure", eventAction: "click" })
    })

    gaScriptIsLoaded = true

    // It's time to execute GA actions if they are in the quere
    while (quere.length) {
        const current = quere.shift()
        current && gaApply(current)
    }
}

/**
 * The function makes sure GA script is included in the app
 * and start initialization of it
 */
const loadScript: VoidFunction = () => {
    const src = "https://www.google-analytics.com/analytics.js"
    const gaScript = document.querySelector("script[src*='" + src + "']")
    if (!gaScript) {
        const script = document.createElement("script")
        script.async = true
        script.src = src
        script.onload = initScript
        const body = document.getElementsByTagName("body")[0]
        body.appendChild(script)
    } else {
        !gaScriptIsLoaded && initScript()
    }
}

export { gaApply, loadScript, GAClientID }
